import { render, staticRenderFns } from "./entrance.vue?vue&type=template&id=9ac1c14a&scoped=true&"
import script from "./entrance.vue?vue&type=script&lang=js&"
export * from "./entrance.vue?vue&type=script&lang=js&"
import style0 from "./entrance.vue?vue&type=style&index=0&id=9ac1c14a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac1c14a",
  null
  
)

export default component.exports